// Xem bản hiển thị PDF của một hóa đơn trong danh sách hợp lệ.
// API trả { result, file } với file là base64, đổi sang blob rồi mới xem được.
import MessageBox from "components/shared-components/MessageBox";
import ReactPdfViewer from "components/shared-components/ReactPdfViewer";
import { base64toBlob } from "helpers/utils";
import { useReviewInvoicePdf } from "hooks/invoiceStatement/useInvoiceStatement";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, Spinner } from "reactstrap";

const styleDiv = {
  width: "100%",
  height: "80vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "#8080802b",
};

const InvoicePdfModal = props => {
  const { isOpen, toggle, invoice } = props;

  const [pdfUrl, setPdfUrl] = useState(null);
  const [isError, setIsError] = useState(false);

  const { mutate } = useReviewInvoicePdf({
    onSuccess: payload => {
      const data = payload?.data;
      if (!data?.result || !data?.file) {
        setIsError(true);
        return;
      }
      setPdfUrl(URL.createObjectURL(base64toBlob(data.file)));
    },
    onError: () => setIsError(true),
  });

  useEffect(() => {
    if (isOpen && invoice?.id) {
      setPdfUrl(null);
      setIsError(false);
      mutate(invoice.id);
    } else {
      setPdfUrl(null);
      setIsError(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, invoice?.id]);

  // Thu hồi object URL cũ để không rò bộ nhớ
  useEffect(
    () => () => {
      if (pdfUrl) URL.revokeObjectURL(pdfUrl);
    },
    [pdfUrl]
  );

  const fileName = `${invoice?.serial || "hoa-don"}-${invoice?.number || ""}`;

  return (
    <Modal
      size="xl"
      contentClassName="confirm-modal"
      isOpen={isOpen}
      role="dialog"
      autoFocus
      centered
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalBody>
          {isError ? (
            <div style={styleDiv}>
              <MessageBox
                variant="danger"
                classMore="d-sm-flex align-items-center justify-content-center gap-1 font-size-18"
              >
                <i className="bx bxs-error-alt" />
                Không xem được file hóa đơn
              </MessageBox>
            </div>
          ) : !pdfUrl ? (
            <div style={styleDiv}>
              <Spinner color="primary" />
            </div>
          ) : (
            <ReactPdfViewer filePdfUrl={pdfUrl} style={{ height: "75vh" }} />
          )}
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="danger" onClick={toggle}>
            Đóng
          </Button>
          {pdfUrl && (
            <Button
              type="button"
              color="success"
              onClick={() => {
                const link = document.createElement("a");
                link.href = pdfUrl;
                link.setAttribute("download", `${fileName}.pdf`);
                document.body.appendChild(link);
                link.click();
                link.remove();
              }}
            >
              <i className="bx bx-download me-1" />
              Tải xuống
            </Button>
          )}
        </ModalFooter>
      </div>
    </Modal>
  );
};

InvoicePdfModal.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func.isRequired,
  invoice: PropTypes.object,
};

InvoicePdfModal.defaultProps = {
  isOpen: false,
  invoice: null,
};

export default InvoicePdfModal;
